var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"extraLarge":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Uppbygging")]),_c('StudyRecordCourse',{attrs:{"studentId":_vm.studentId,"courseId":_vm.courseId,"item":_vm.course,"slidebar":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }